import React, { AnchorHTMLAttributes, CSSProperties, HTMLAttributeAnchorTarget } from "react";
import styles from "./cta-link.module.scss";
import classnames from "classnames";

export type CtaLinkProps = {
  href?: string;
  target?: HTMLAttributeAnchorTarget;
  className?: string;
  onClick?: (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void;
  children?: React.ReactNode;
  skin?: "button" | "anchor";
  disabled?: boolean;
  onMouseEnter?: VoidFunction;
  onMouseLeave?: VoidFunction;
  darkMode?: boolean;
  weight?: "extraBold" | "bold" | "normal" | "thin";
  size?: "extraSmall" | "small" | "medium" | "large";
  download?: string;
  style?: CSSProperties;
};

export const CtaLink: React.FC<CtaLinkProps> = React.memo(
  ({
    href,
    target = "_blank",
    className,
    onClick,
    children,
    skin = "anchor",
    disabled,
    onMouseEnter,
    onMouseLeave,
    darkMode,
    weight = "normal",
    size = "small",
    download,
    style,
  }) => {
    const aProps: AnchorHTMLAttributes<HTMLAnchorElement> = {
      className: classnames(styles.ctaLink, className, styles[skin], styles[weight], styles[size], {
        [styles.disabled]: disabled,
        [styles.darkMode]: darkMode,
      }),
      href,
      onClick,
      onMouseEnter,
      onMouseLeave,
      download,
      style,
    };

    if (href) {
      aProps.target = target;
    }

    return <a {...aProps}>{children}</a>;
  }
);
